import { PageContent } from "../content";
import { useRevealOnScroll } from "../hooks/useRevealOnScroll";

export function PurposeSection({ copy }: { copy: PageContent }) {
  const ref = useRevealOnScroll<HTMLDivElement>();

  return (
    <section id="purpose" className="purpose" aria-label={copy.purposeLabel}>
      <div ref={ref} className="purpose-copy reveal">
        <p className="section-label">{copy.purposeLabel}</p>
        <h2>{copy.purposeTitle}</h2>
        <span className="accent-line" aria-hidden="true" />
        <p className="purpose-text">{copy.purposeText}</p>
      </div>
    </section>
  );
}
